export default __webpack_public_path__ + "static/media/object_window1.3db94133.png";